import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "../../../../axios/index";

// Context
import { UserContext } from "../../../Context/UserContextProvider";

// components
import ShowProfileModal from "../../DashboardFileManagement/CardDetail/ShowProfileModal";
import DashboardHeader from "../../DashboardReuseAbleComponents/DashboardHeader";
import DashboardSideMenu from "../../DashboardReuseAbleComponents/DashboardSideMenu";
import { Pagination, Stack } from "@mui/material";
import { Link } from "react-router-dom";

// Styles
import styles from "./../StaffManagment.module.css";
import Dstyles from "./../../DashboardFileManagement/DashboardFileManagement.module.css";

// Images
import arrowIcon from "./../../../../assets/img/DashboardICons/ArrowRounded.svg";
import arrowBlue from "./../../../../assets/img/DashboardICons/ArrowLeftBlue.svg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const StaffColleaguesInfoNotifDetail = () => {
  const { userToken } = useContext(UserContext);
  const [modalShow, setModalShow] = useState(false);
  const history = useHistory();

  // const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);

  const [staffNotifDetailData, setStaffNotifDetailData] = useState([]);

  useMemo(() => staffNotifDetailData, [staffNotifDetailData]);

  useEffect(() => {
    const dataHandler = async () => {
      // setIsLoading(true)

      const getConsultant = await axios.get("Consultant/ConsultantsForAdmin?Status=1", {
        headers: { authorization: "Bearer " + userToken },
      });
      // console.log(getConsultant)

      const consultant = getConsultant.data.data.data.filter(item => item.status === 1);
      setStaffNotifDetailData(consultant);
      // console.log(consultant)

      setIsLoading(false);
    };

    dataHandler();
  }, [userToken]);

  // async function paginationHandler(event, value) {
  //     setIsLoading(true)
  //     const getConsultant = await axios.get(
  //         `Consultant/ConsultantsForAdmin?Status=1&PageId=${value}`,
  //         {
  //             headers: { authorization: "Bearer " + userToken },
  //         }
  //     );

  //     console.log(getConsultant)
  //     const consultant = getConsultant.data.data.data.filter(item => item.status === 1);
  //     setStaffNotifDetailData(consultant)
  //     setPage(value); // value is the pages number
  //     // console.log(value)
  //     setIsLoading(false)
  // }

  return (
    <>
      <ShowProfileModal show={modalShow} onHide={() => setModalShow(false)} />
      {isLoading ? (
        <div className={Dstyles.loader_container}>
          <div className={Dstyles.spinner}></div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-9">
              <div className={`my-3 pb-4 px-0 ${styles.file_cards_container}`}>
                <DashboardHeader onClick={() => setModalShow(true)} class="px-0" />

                <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-4 mx-4 px-2" dir="rtl">
                  <div className="d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2">
                    <a href="#" onClick={history.goBack}>
                      <img className="ms-2" src={arrowIcon} alt="icon" />
                    </a>
                    <div className={styles.text1}>درخواست های مشاور</div>
                  </div>
                </div>

                {/* Total Staff Managment Info */}

                <div dir="rtl" className={`mt-4 mx-4 px-2`}>
                  {staffNotifDetailData?.map(data => (
                    <div
                      key={data.id}
                      className={`mt-4 mb-3 p-3 d-flex justify-content-between align-items-center flex-wrap ${styles.total_staff_notif_detail_box}`}>
                      <h4 className={`mb-0 ${styles.title_staff_notif_detail_box}`}>{data.name + " " + data.family}</h4>
                      <div>
                        <span className={`${styles.subtitle_staff_notif_detail_box}`} style={{ color: "#8d8d8d" }}>
                          {" "}
                          تاریخ ثبت نام:{" "}
                        </span>
                        <span className={`${styles.subtitle_staff_notif_detail_box}`} style={{ color: "#363636" }}>
                          {" "}
                          {data.registerDate}{" "}
                        </span>
                      </div>
                      <Link
                        to={{
                          pathname: `/staff-managment-colleagues-info-notif-detail-info/${data.id}`,
                          state: data,
                        }}
                        style={{ color: "#21409a" }}
                        className={`${styles.link_icon_text}`}>
                        بیشتر
                        <img className="p-2" src={arrowBlue} alt="arrow-left-blue" width="29" />
                      </Link>
                    </div>
                  ))}
                </div>

                {/* <Stack
                                        className={Dstyles.pagination}
                                        spacing={1}
                                        sx={{
                                            direction: "ltr",
                                            bottom: "0",
                                            height: "85px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center !important",
                                        }}
                                    >
                                        <CustomPagination count={5} variant="outlined" shape="rounded" page={page} onChange={paginationHandler} />
                                    </Stack> */}
              </div>
            </div>
            <div className="col-md-3">
              {/* sideMenu starts */}
              <DashboardSideMenu managePersonal manageStaffInfo />
              {/* sideMenu ends */}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StaffColleaguesInfoNotifDetail;
